import React, { useState, useEffect } from 'react'
import { Layout, message } from 'antd'
import './index.scss'
import {openLoginCode, queryinfo} from 'src/https/userCente'

import LoginPage from './login'
import Ocr from './ocr'

const { Header, Content } = Layout

const Home: React.FC = () => {
	const [ocrData, setOcrData] = useState('loading')
	
	const getQueryString = (name:string) => {
		const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		const r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	}

	useEffect(() => {
		const code = getQueryString('code')
		if(code){
			openLoginCode({code: code}).then((res:any) => {
				const {data} = res
				if(data.status === 0){
					window.location.href = '/'
				}else{
					message.warning(data.msg)
				}
			})
		}else{
			queryinfo().then((res: any) => {
				const {data:ocrInfo} = res
				if(ocrInfo.status === 0){
					setOcrData(ocrInfo.data)
				}else{
					setOcrData('')
				}
			})
		}
	},[])

	return (
		<Layout className='ocr-layout'>
			<Header className='ocr-header'>
				<div className='header-container'>
					<img src="https://pic.001pt.com/logo/logo.png" alt="logo"/>
					<div className='header-menu'>
						<a className='header-menu-link' href='https://www.001pt.com/'>首页</a>
						<a className='header-menu-btn-login' href="https://www.001pt.com/login/">登录</a>
						<a className='header-menu-btn-register' href="https://www.001pt.com/login/register.html">免费注册</a>
					</div>
				</div>
			</Header>
      <Content>
				{
					ocrData === 'loading' ? '' : ocrData ?  <Ocr ocrData={ocrData} setOcrData={setOcrData}/> : <LoginPage/>
				}
			</Content>
		</Layout>
	)
}

export default Home;